import React, { forwardRef } from 'react';
import './Input.scss';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    error?: string;
    helperText?: string;
    leftIcon?: React.ReactNode;
    rightIcon?: React.ReactNode;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
    ({ label, error, helperText, leftIcon, rightIcon, className = '', ...props }, ref) => {
        const classes = [
            'input-wrapper',
            error && 'has-error',
            props.disabled && 'disabled',
            leftIcon && 'has-left-icon',
            rightIcon && 'has-right-icon',
            className,
        ].filter(Boolean).join(' ');

        return (
            <div className="form-group-custom">
                {label && <label className="input-label">{label}</label>}
                <div className={classes}>
                    {leftIcon && <span className="input-icon left">{leftIcon}</span>}
                    <input
                        ref={ref}
                        className="input-field"
                        {...props}
                    />
                    {rightIcon && <span className="input-icon right">{rightIcon}</span>}
                </div>
                {error && <span className="input-error">{error}</span>}
                {helperText && !error && <span className="input-helper">{helperText}</span>}
            </div>
        );
    }
);

Input.displayName = 'Input';

export default Input;
